import { back, handWave, salad } from "../../../Assets";
// import { STRINGS } from "../../../Shared/Constant";
import { StyledSVG } from "../../../Utils/style";

const AppHeader = ({
  table_detail,
  navigate,
  backButton,
  left = false,
  backHandler,
}) => {
  return (
    <>
      <img
        className="background-image"
        id="header-background-img"
        alt=""
        src={salad}
      />
      <div className="container image-border">
        <div className="row align-items-center mx-3">
          <div className="col-4 mx-0 px-0">
            {backButton ? (
              // <p className="back-text" onClick={() => navigate(-1)}>
              //   <img alt="" src={back} />
              //   {STRINGS.BACK}
              // </p>
              <span className="back-text" onClick={() => backHandler()}>
                <StyledSVG
                  color={
                    table_detail?.QrOrdering?.brand_main_color || "#8b8b8b"
                  }
                  src={back}
                  width="20"
                />
                {"Back"}
              </span>
            ) : left ? (
              <span className="d-flex align-items-center">
                <StyledSVG className="mr-2" src={handWave} width={20} />
                <p className="appheader-call">Call Server</p>
              </span>
            ) : (
              <span></span>
            )}
          </div>
          <div className="col-4">
            <div className="bg-white translate-image">
              <img
                className="logo mx-auto d-block"
                src={table_detail?.Merchant?.logo}
                alt=""
              />
            </div>
          </div>
          <div className="col-4">
            <p className="text-end table-name">
              {"Table"} <b>{table_detail?.PosTableMaster?.table_number}</b>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppHeader;
